export const selectAllAssessmentList = (state) => state.allassessmentlists;
